import { get } from '../../../../../infra/rest';
import { DialogContentData } from '../typings';

export const getUserDialogContent = async () => {
  return get<DialogContentData>('/v1/demo/dialog-content', {}, true);
};
